<script>
</script>

<main>
	<h1>Reviews</h1>
	<hr><br>
	<div class="reviews">
		<div class="cool-box">
			<img class="icon" src="assets/Google__G__Logo.svg.png" alt="Google Logo">
			<h2>Google Reviews</h2>
			<span class="fa fa-star checked gold"></span>
			<span class="fa fa-star checked gold"></span>
			<span class="fa fa-star checked gold"></span>
			<span class="fa fa-star checked gold"></span>
			<span class="fa fa-star"></span>
			<p>4.6 stars - 19 reviews</p>
		</div>
		<hr>
		<p>If you enjoyed your appointment, please feel free to leave a review!</p>
		<a class="btn" href="https://www.google.com/search?q=shoreline+family+dentistry&oq=shoreline+family+dentistry&aqs=chrome..69i57j69i59j69i61j69i60j69i61.10986j0j7&sourceid=chrome&ie=UTF-8#lrd=0x549010e72e64f2c1:0xc0c3bbb59147744,1,,,">Leave a review >>></a>
		<br><br>
	</div>
	<br>
	<div class="testimonials">
		<h2>Testimonials</h2>
		<div class="row">
			<div class="column">
				<p><i>"Dr. Kang has been my dentist for over 10 years... My #1 reason for him being my dentist is he is incredibly gentle... I highly recommend him and his staff - they are superior. The best I've ever had in my 60-something years." - S.P.</i></p>
				<p><i>"As always, the staff is friendly and professional. The doctor listens, and answers my questions. Everything is clean and bright." - T.R.</i></p>
				<p><i>"I've never been treated so well by a dentist. His staff and personal behavior is very friendly and comforting. They are a small business, so they remember their customers and treat them well. Dr. Kang always communicates clearly with the patient to make sure they understand any issues they may have arised, or to offer advice.  I've never complained with any of his procedures or had problems with anything afterwards." - H.K.</i></p>
				<p><i>"I have been going to them for four or five years. They are the best dental clinic I have ever gone to. My teeth have never been in better condition and care. Everyone is very nice and professional." - F.Y.</i></p>
			</div>
			<div class="column">
				<p><i>"I honestly have the best dentist in the state of Washington!! S.F.D. also has the best staff with the up most friendly, helpful customer service. I personally love my visits every 6 months and look forward to them. Any questions or concerns are always answered with even further helpful information. I recommend S.F.D. to everyone that I speak to with regards to dentistry." - M.G.</i></p>
				<p><i>"Very awesome staff and personalized care. Will treat you as a family. Dr. Kang is the best dentist ever...." - L.B.</i></p>
				<p><i>"Dr. Kang and his staff have been caring for my entire family for several years. He is jovial and always willing to explain every procedure. He is a perfectionist, and our teeth have never looked better. I recommend him to all my friends without any hesitation... He will sit and answer all of your questions, until you are completely satisfied... In my view, the best dentist I've ever had in my entire life." - M.K.</i></p>
				<p><i>"I love my dentist and all of the support staff! They are professional, efficient and friendly!" - E.M.</i></p>
			</div>
		</div>
	</div>
	
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	p{
		padding-bottom: 16px;
	}

	.btn {
		background-color: rgb(116, 176, 211);
		border: none;
		color: white;
		padding: 12px 30px;
		cursor: pointer;
		font-size: 20px;
		transition: .1s;
		text-decoration: none;
	}

	/* Darker background on mouse-over */
	.btn:hover {
		background-color: rgb(52, 80, 117);
	}

	.row {
  		display: flex;
	}

	.column {
		flex: 50%;
		padding: 0px 32px;
	}

	.reviews {
		padding: 2em 6em;
		background-color: aliceblue;
		border-radius: 15px;
	}

	.testimonials{
		padding: 2em 6em;
		background-color: aliceblue;
		border-radius: 15px;
	}

	.gold {
		color: gold;
	}

	.cool-box {
		padding:2em 2em 0.5em 2em;
		background-color: white;
		border-radius: 15px;
	}

	.icon {
		max-width: 100px;
		max-height: 100px;
	}

</style>